export interface GossipItem {
  id: string;
  section: string;
  title: string;
  summary: string;
  tag: string;
  time: string;
  views: string;
  comments: string;
  img: string;
  alt: string;
}

export interface FeatureTopic {
  id: string;
  eyebrow: string;
  title: string;
  desc: string;
  img: string;
  alt: string;
  reads: string;
}

export const hotTags = ['明星', '影视', '综艺', '音乐', '社会', '文旅', '票房', '饭圈', '短剧', '时尚'];

export const trending = [
  { rank: 1, title: '现象级音综“黑马舞台”全网刷屏，三小时播放破千万', tag: '综艺', heat: '爆', delta: 'up' },
  { rank: 2, title: '演唱会带火一座城，文旅融合再添“城市新名片”样本', tag: '社会', heat: '热', delta: 'up' },
  { rank: 3, title: '老牌组合时隔六年合体，舞台“回忆杀”直击青春记忆', tag: '明星', heat: '爆', delta: 'up' },
  { rank: 4, title: '新剧杀青路透刷屏，古装制作在服化道上下足功夫', tag: '影视', heat: '热', delta: 'down' },
  { rank: 5, title: '暑期档票房回暖，类型片多线突围成为市场亮点', tag: '票房', heat: '热', delta: 'flat' },
  { rank: 6, title: '博物馆夜游持续升温，年轻人爱上“沉浸式逛展”', tag: '文旅', heat: '新', delta: 'up' },
  { rank: 7, title: '歌手巡演官宣连开八场，抢票攻略瞬间冲上热搜', tag: '音乐', heat: '热', delta: 'up' },
  { rank: 8, title: '短剧出海加速，中式叙事持续圈粉海外观众', tag: '短剧', heat: '新', delta: 'down' },
];

export const flashes = [
  { time: '14:26', text: '年度音乐盛典官宣定档，全阵容海报释出引发期待' },
  { time: '12:08', text: '多部新片集中发布预告，国庆档片单竞争提前升温' },
  { time: '10:45', text: '一档新文旅综艺公布常驻嘉宾，取景地引发打卡潮' },
  { time: '09:12', text: '老牌剧集宣布启动翻拍企划，选角成全网讨论焦点' },
];

export const starNews: GossipItem[] = [
  {
    id: 's1', section: '明星', title: '年度华语音乐盛典红毯落幕，“同款”造型一夜成话题',
    summary: '盛典之夜群星闪耀，多位艺人的红毯造型接连登上热搜，同色系与复古元素的组合成为本次最大赢家，时尚解读引发多轮讨论。',
    tag: '红毯', time: '2小时前', views: '128万', comments: '8600', img: 'https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20evening%20gala%20with%20warm%20stage%20lights%20and%20elegant%20crowd%20silhouettes%2C%20cinematic%20editorial%20entertainment%20photography%2C%20soft%20golden%20glow%2C%20refined%20magazine%20style&width=800&height=600&seq=star-01&orientation=landscape', alt: '华语音乐盛典红毯之夜现场图' },
  {
    id: 's2', section: '明星', title: '现象级综艺开播即爆，“黑马舞台”让素人一夜出圈',
    summary: '开播首期话题量便登顶热搜，一档竞演综艺靠真实舞台与动人故事杀出重围，选手背后的成长线成为观众追更的最大动力。',
    tag: '综艺', time: '4小时前', views: '96万', comments: '5400', img: 'https://readdy.ai/api/search-image?query=energetic%20variety%20show%20stage%20with%20a%20young%20performer%20under%20warm%20spotlights%2C%20cheering%20studio%20audience%2C%20vibrant%20live%20atmosphere%2C%20editorial%20entertainment%20photography&width=800&height=600&seq=star-02&orientation=landscape', alt: '综艺竞演舞台选手表演现场图' },
  {
    id: 's3', section: '明星', title: '老牌组合时隔六年再度合体，舞台掀起全网“回忆杀”',
    summary: '官宣即霸榜，合体彩排的花絮引发集体青春回忆。团队表示将带来全新改编舞台，既是重逢，也是写给歌迷的一封信。',
    tag: '音乐', time: '6小时前', views: '203万', comments: '1.2万', img: 'https://readdy.ai/api/search-image?query=vintage%20boyband%20reunion%20on%20concert%20stage%20with%20warm%20nostalgic%20purple-free%20lighting%2C%20emotional%20crowd%20with%20light%20sticks%2C%20cinematic%20concert%20photography&width=800&height=600&seq=star-03&orientation=landscape', alt: '老牌组合演唱会合体现场图' },
  {
    id: 's4', section: '明星', title: '新剧杀青路透刷屏，古装制作在服化道上“卷”出新高度',
    summary: '一组横店杀青路透迅速出圈，考究的服饰与场景细节被网友逐帧扒出。制作团队表示为还原年代质感前后打磨近一年。',
    tag: '影视', time: '8小时前', views: '74万', comments: '3100', img: 'https://readdy.ai/api/search-image?query=period%20chinese%20costume%20drama%20set%20on%20a%20film%20lot%20with%20traditional%20architecture%20and%20elegant%20hanfu%20costumes%2C%20warm%20cinematic%20lighting%2C%20editorial%20production%20still&width=800&height=600&seq=star-04&orientation=landscape', alt: '古装剧横店杀青路透现场图' },
  {
    id: 's5', section: '明星', title: '歌手巡演官宣连开八场，抢票攻略瞬间冲上热搜',
    summary: '演唱会经济持续升温，某歌手官宣全国八场巡回并放出先导预告，粉丝热传“抢票攻略”，场馆周边也带火了当地文旅消费。',
    tag: '演出', time: '10小时前', views: '156万', comments: '9900', img: 'https://readdy.ai/api/search-image?query=large%20concert%20tour%20announcement%20poster%20wall%20with%20arena%20stage%20lights%20and%20enthusiastic%20fans%20raising%20phones%2C%20warm%20concert%20photography&width=800&height=600&seq=star-05&orientation=landscape', alt: '歌手巡回演唱会官宣现场图' },
  {
    id: 's6', section: '明星', title: '综艺收官夜名场面频出，网友直呼“入股不亏”',
    summary: '一档常青综艺迎来本季收官，高光片段与即兴互动刷屏社交平台，稳定高质量的内容让观众对下一季充满期待。',
    tag: '综艺', time: '12小时前', views: '88万', comments: '4200', img: 'https://readdy.ai/api/search-image?query=colorful%20game%20show%20finale%20with%20hosts%20and%20guests%20laughing%20on%20a%20bright%20studio%20set%2C%20confetti%20falling%2C%20joyful%20live%20television%20photography&width=800&height=600&seq=star-06&orientation=landscape', alt: '综艺节目收官夜录制现场图' },
];

export const socialNews: GossipItem[] = [
  {
    id: 'c1', section: '社会', title: '演唱会带火一座城，文旅融合催生“城市新名片”',
    summary: '一场万人演唱会带火了整座城市的旅游、餐饮与住宿消费。如何把“短暂的流量”沉淀成“长久的吸引力”，成为各地探索的新命题。',
    tag: '文旅', time: '1小时前', views: '142万', comments: '6100', img: 'https://readdy.ai/api/search-image?query=vibrant%20city%20nightscape%20with%20concert%20glow%20and%20crowds%20of%20tourists%20walking%20along%20a%20lively%20downtown%20street%2C%20warm%20city%20lights%2C%20editorial%20travel%20photography&width=800&height=600&seq=social-01&orientation=landscape', alt: '演唱会带动城市文旅消费夜景图' },
  {
    id: 'c2', section: '社会', title: '暑期档票房回暖，类型片多线突围成市场亮点',
    summary: '暑期档交出亮眼成绩单，现实题材与类型片齐头并进。观众用脚投票，说明优质内容仍是票房增长最稳固的底座。',
    tag: '票房', time: '3小时前', views: '117万', comments: '4800', img: 'https://readdy.ai/api/search-image?query=cozy%20cinema%20auditorium%20with%20glowing%20screen%20during%20a%20packed%20film%20screening%2C%20silhouettes%20of%20audience%2C%20warm%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=social-02&orientation=landscape', alt: '暑期档电影院内观众观影现场图' },
  {
    id: 'c3', section: '社会', title: '博物馆夜游持续升温，年轻人爱上“沉浸式逛展”',
    summary: '“夜游博物馆”成为年轻人的周末新玩法，灯光展陈、讲解导览与文创周边叠加出圈。文物不再束之高阁，而成了社交货币。',
    tag: '文旅', time: '5小时前', views: '89万', comments: '3600', img: 'https://readdy.ai/api/search-image?query=night%20tour%20inside%20a%20grand%20museum%20hall%20with%20elegant%20lighting%20on%20ancient%20artifacts%20and%20visitors%20admiring%20exhibits%2C%20warm%20refined%20editorial%20photography&width=800&height=600&seq=social-03&orientation=landscape', alt: '博物馆夜游沉浸式逛展现场图' },
  {
    id: 'c4', section: '社会', title: '国潮市集遍地开花，“情绪消费”成新增长点',
    summary: '从手作体验到特色小吃，国潮市集把“逛”变成一种情绪出口。体验感与内容感并重，让线下消费重新有了烟火气与人情味。',
    tag: '消费', time: '7小时前', views: '65万', comments: '2700', img: 'https://readdy.ai/api/search-image?query=busy%20chinese%20style%20night%20market%20with%20handmade%20craft%20booths%2C%20warm%20string%20lights%20and%20young%20crowds%20browsing%2C%20festive%20editorial%20street%20photography&width=800&height=600&seq=social-04&orientation=landscape', alt: '国潮市集夜市人气现场图' },
  {
    id: 'c5', section: '社会', title: '短剧出海加速，中式叙事持续圈粉海外观众',
    summary: '越来越多中式短剧登上海外榜单，快节奏叙事与普世情感结合，让海外观众在“追更”中读懂中国文化，成为新的文化输出窗口。',
    tag: '短剧', time: '9小时前', views: '103万', comments: '5200', img: 'https://readdy.ai/api/search-image?query=global%20short%20drama%20streaming%20culture%20concept%20with%20globe%20and%20play%20interface%20overlaying%20a%20modern%20studio%2C%20warm%20tech%20editorial%20photography&width=800&height=600&seq=social-05&orientation=landscape', alt: '中式短剧出海文化现象示意图' },
  {
    id: 'c6', section: '社会', title: '城市漫步走红，慢生活成为周末新选择',
    summary: '不赶景点、不刷路线，越来越多的年轻人选择“城市漫步”来放空自己。把脚步放慢，反而更能发现身边被忽略的美。',
    tag: '生活', time: '11小时前', views: '58万', comments: '2100', img: 'https://readdy.ai/api/search-image?query=two%20young%20friends%20walking%20slowly%20through%20a%20tree%20lined%20city%20street%20in%20warm%20afternoon%20sunlight%2C%20relaxed%20weekend%20city%20strolling%2C%20editorial%20lifestyle%20photography&width=800&height=600&seq=social-06&orientation=landscape', alt: '年轻人在城市街道漫步休闲图' },
];

export const features: FeatureTopic[] = [
  {
    id: 'f1', eyebrow: '年度盘点', title: '2026 上半年娱乐行业十大热议事件',
    desc: '从爆款综艺到票房黑马，从舞台新声到文化出海，上半年娱乐行业的十个高光与反思瞬间，我们用一条时间线为你完整复盘。',
    reads: '38万次阅读', img: 'https://readdy.ai/api/search-image?query=editorial%20collage%20of%20entertainment%20industry%20highlights%20with%20film%20posters%20concert%20lights%20and%20news%20headlines%20arranged%20elegantly%2C%20warm%20magazine%20layout&width=800&height=600&seq=feature-01&orientation=landscape', alt: '2026上半年娱乐行业年度盘点专题图' },
  {
    id: 'f2', eyebrow: '深度观察', title: '从舞台到银幕，素人出圈的路径正在改变',
    desc: '选秀时代落幕，素人如何再度走向聚光灯？我们拆解综艺、短视频与舞台剧的三条新路径，看流量与才华如何重新平衡。',
    reads: '26万次阅读', img: 'https://readdy.ai/api/search-image?query=rising%20star%20path%20concept%20with%20spotlight%20staircase%20leading%20up%20to%20bright%20stage%2C%20person%20silhouette%20climbing%2C%20motivational%20warm%20editorial%20photography&width=800&height=600&seq=feature-02&orientation=landscape', alt: '素人出圈路径深度观察专题图' },
  {
    id: 'f3', eyebrow: '产业观察', title: '影视综联动：一个 IP 如何长成超级生态',
    desc: '剧、影、综、游多端联动已成为头部 IP 的共同选择。热度的尽头是情感，情感的落地是生态，我们聊聊 IP 运营的底层逻辑。',
    reads: '21万次阅读', img: 'https://readdy.ai/api/search-image?query=interconnected%20media%20ecosystem%20concept%20with%20glowing%20network%20linking%20film%20drama%20variety%20and%20game%20icons%2C%20warm%20abstract%20editorial%20illustration&width=800&height=600&seq=feature-03&orientation=landscape', alt: '影视综IP联动产业生态专题图' },
];

export const aboutStats = [
  { num: '2800万+', label: '累计内容阅读' },
  { num: '120+', label: '日均热点更新' },
  { num: '8大', label: '精品内容栏目' },
  { num: '7×24', label: '热点实时追踪' },
];

export const aboutPoints = [
  { icon: 'ri-eye-line', title: '真实为先', desc: '坚持多方信源交叉核验，转载必注明出处，不轻信、不传谣，把客观摆在流量前面。' },
  { icon: 'ri-flashlight-line', title: '极速速递', desc: '第一现场、第一手瓜料，编辑 7×24 在线盯热点，把最新最热的内容第一时间送到你面前。' },
  { icon: 'ri-shield-check-line', title: '内容有尺', desc: '尊重当事人与版权，拒绝恶意炒作与低俗猎奇，让吃瓜有温度、讨论有边界。' },
  { icon: 'ri-heart-line', title: '与用户共成长', desc: '开放投稿与留言，认真对待每一条反馈，让平台真正成为属于每一位吃瓜用户的共享内容空间。' },
];

export const faqs = [
  {
    q: '吃瓜视界是一个什么样的平台？',
    a: '吃瓜视界是一站式娱乐资讯与吃瓜内容聚合门户。我们聚焦明星八卦、影视综艺、音乐演出、社会热点与文旅消费等话题，以资讯速递、深度专题和话题讨论的形式，帮助用户高效追热点、理性看瓜、畅快分享。',
  },
  {
    q: '吃瓜视界的内容多久更新一次？',
    a: '我们设有 7×24 小时的编辑值班机制。明星官宣、演出定档、票房数据、热搜话题等热点内容通常在事件发生后几分钟到几小时内完成整理上线，日均更新内容超过 120 条。',
  },
  {
    q: '如何保证内容真实、可靠？',
    a: '吃瓜视界坚持“真实为先”的内容原则。编辑在发布前会对多方信源进行交叉核验，转载内容均注明原始出处；对于无法确认或仍处于争议阶段的爆料，我们会明确标注“待核实”，并持续跟进官方回应。',
  },
  {
    q: '吃瓜视界支持投稿和爆料吗？需要收费吗？',
    a: '支持。任何人都可以通过页面底部“线索投稿”表单提交素材，一经采纳我们会在与投稿人确认后编辑发布。目前投稿、浏览和内容阅读均完全免费，平台不向用户收取任何费用。',
  },
  {
    q: '吃瓜视频在线观看和免费播放是真实的吗？',
    a: '吃瓜视界以资讯与图文内容为核心，同时为用户聚合整理由正规版权渠道提供的公开内容入口与观看指引，帮助大家更快找到想看的高清资源，不提供任何盗版或侵权播放源。',
  },
  {
    q: '遇到涉及当事人权益或争议的内容，平台如何处理？',
    a: '我们高度重视内容合规与当事人权益。若涉及失实信息或隐私争议，可在“联系我们”表单中说明情况并提供证据，审核团队会在 24 小时内核实并按规则处理，必要时做下线或致歉更正。',
  },
];

export const footerLinks = [
  { title: '热点栏目', links: ['明星八卦', '影视前线', '综艺现场', '音乐榜单', '社会观察', '文旅风向'] },
  { title: '编辑精选', links: ['年度盘点', '深度观察', '产业前瞻', '理性吃瓜指南', '话题讨论'] },
  { title: '帮助中心', links: ['平台介绍', '投稿指南', '内容规范', '版权声明', '隐私政策', '联系我们'] },
];